import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown, BsThreeDots } from "@/Components/Icons/Icons";
import { data } from "react-router";
export default {
  row1: [
    {
      column: "column1",
      //   columnWidth: "60%",
      rows: {
        row1: [
          {
            name: "otherDutyIsCustomsCVD",
            checkboxLabel: "Customer CVD",
            component: "checkboxbox",
          },
        ],
        row2: [
          {
            name: "otherDutyNotn",
            label: "Notn",
            component: "text-field",
            dependsOn: "otherDutyIsCustomsCVD",
            width: "30%",
          },
          {
            name: "otherDutySrNo",
            label: "Sr No.",
            component: "text-field",
            icon: LuSearch,
            dependsOn: "otherDutyIsCustomsCVD",
            width: "30%",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              otherDutyNotn: "notation",
              otherDutyDuty: "rate",
            },
          },
        ],
        row3: [
          {
            name: "otherDutyItemSrNo",
            label: "Item Serial No.",
            component: "text-field",
            dependsOn: "otherDutyIsCustomsCVD",
            width: "30%",
          },
          {
            name: "otherDutySupplierSrNo",
            label: "Supp Sr. No.",
            component: "text-field",
            dependsOn: "otherDutyIsCustomsCVD",
            width: "30%",
          },
        ],
        row4: [
          {
            name: "otherDutyDuty",
            label: "Duty",
            component: "text-field",
            placeholder: "0.00",
            dependsOn: "otherDutyIsCustomsCVD",
            width: "27%",
            dataType:"float"
          },
          {
            name: "RoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4, ml: -1 },
          },
          {
            name: "otherDutyCalcMethod",
            label: "Calc.Method",
            component: "dropdown",
            options: [
              { label: "%age of Landed Value", value: "%age of Landed Value" },
              { label: "%age of CIF", value: "%age of CIF" },
              { label: "%age of Landed Value less ADD",value: "%age of Landed Value less ADD",
              },
            ],
            dependsOn: "otherDutyIsCustomsCVD",
            width: "30%",
          },
        ],
        row5: [
          {
            name: "otherDutyIsAntidumping",
            checkboxLabel: "Anti-Dumping",
            component: "checkboxbox",
            sx: { mt: 5 },
          },
        ],
        row6: [
          {
            name: "otherDutyDumpNotation",
            label: "Notn",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            width: "27%",
            type: "autocomplete",
            endpoint: "getNotation",
          },
          {
            name: "NotnNumber",
            component: "outlinebutton",
            sx: {
              mt: "33px",
            },
            width: "2%",
            iconName: BsThreeDots,
            dependsOn: "otherDutyIsAntidumping",
          },

          {
            name: "otherDutyDumpSrNo",
            label: "Sr No.",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            width: "25%",
          },
        ],
        row7: [
          {
            name: "otherDutyDumpCthSerialNumber",
            label: "CTH Serial No.",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            width: "30%",
          },
          {
            name: "otherDutyDumpSupplierSrNo",
            label: "Supp Sr.No.",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            width: "30%",
          },
        ],
        row8: [
          {
            name: "otherDutyDumpQuantity",
            label: "Quantity",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            placeholder: "0.00",
            dataType:"float",
            width: "30%",
          },
          {
            name: "otherDutyDumpCalcMethod",
            label: "Calc Method",
            component: "dropdown",
            options: [
              { label: "%age of Assbl. Value", value: "ageofAssblalue" },
              { label: "%age of Landed Value", value: "ageofLandedValue" },
              { label: "%age of CIF", value: "ageofCIF" },
              { label: "Specific on Qty", value: "SpecificonQty" },
              { label: "Difference of landed & Specific",value: "DifferenceoflandedSpecific"},
              { label: "%of Landed less CCVD", value: "ofLandedlessCCVD" },
            ],
            dependsOn: "otherDutyIsAntidumping",
            width: "30%",
          },
        ],
        row9: [
          {
            name: "otherDutyDumpDuty",
            label: "Duty",
            component: "text-field",
            dependsOn: "otherDutyDumpCalcMethod",   // 🔥 MUST GIVE THIS
            placeholder: "0.00",
            dataType:"float"
          },
          
          {
            name: "RoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4, ml: -1 },
            dependsOn: "",
          },
          {
            name: "otherDutyDumpCurrency",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getExchange",
            dependsOn: "otherDutyIsAntidumping",
          },
          {
            name: "otherDutyQuantityPrice",
            component: "text-field",
            dependsOn: "otherDutyIsAntidumping",
            placeholder: "0.00",
            dataType:"float"
          },
          {
            name: "RoadInfraaneousrate",
            actionText: "/",
            component: "typographytext",
            sx: { mt: 4,},
          },
          {
            name: "otherDutyDumpQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
            dependsOn: "otherDutyIsAntidumping",
          },
        ],
        row10: [
          {
            name: "otherDutyIsOtherDuties",
            checkboxLabel: "Other Duties[Under Section3(3)]",
            component: "checkboxbox",
            sx: { mt: 5 },
          },
        ],
        row11: [
          {
            name: "otherDutyOtherNotation",
            label: "Notn.",
            component: "text-field",
            dependsOn: "otherDutyIsOtherDuties",
          },
          {
            name: "otherDutyNotationValues",
            component: "text-field",
            dependsOn: "otherDutyIsOtherDuties",
            type: "autocomplete",
            endpoint: "getNotation"
          },
          {
            name: "otherDutyPercentage",
            component: "text-field",
            placeholder: "0.00",
            dependsOn: "otherDutyIsOtherDuties",
            dataType:"float"

          },
          {
            name: "RoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4, ml: -1 },
            dependsOn: "otherDutyIsOtherDuties",
          },
          {
            name: "otherDutyLevel",
            component: "dropdown",
            placeholder: "0.00",
            dependsOn: "otherDutyIsOtherDuties",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            dataType:"float"

          },
          {
            name: "otherDutyQuantity",
            component: "text-field",
            dependsOn: "otherDutyIsOtherDuties",
            placeholder: "0.00",
            dataType:"float"

          },
          {
            name: "otherDutyQuantityValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
            dependsOn: "otherDutyIsOtherDuties",
          },
        ],
        row12: [
          {
            name: "otherDutyType",
            label: "Duty Type",
            component: "text-field",
            dependsOn: "otherDutyIsOtherDuties",
            width: "30%",
          },
        ],
        row13: [
          {
            name: "otherDutyAdditionalDuty",
            label: "Addl Duty Flag",
            component: "text-field",
            dependsOn: "otherDutyIsOtherDuties",
            width: "30%",
            dataType:"float"
          },
        ],
      },
    },
  ],
};
